import {Injectable} from '@angular/core';
import {BehaviorSubject, Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class StepsService {
  step = 1;
  step$: BehaviorSubject<number> = new BehaviorSubject<number>(this.step);


  constructor() {

  }


  nextStep() {

    if (this.step === 3) {
      return false;
    }

    this.step++;
    history.pushState(null, null, location.href);
    this.step$.next(this.step);

  }

  prevStep() {
    if (this.step === 1) {
      return false;
    }
    this.step--;

    history.pushState(null, null, location.href);
    this.step$.next(this.step);
  }

  setStep(stepNumber: number){
    this.step = stepNumber;
    this.step$.next(this.step);
  }

}
